import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AutomationErrorAlerts = ({ alerts, onDismiss, onRetry }) => {
  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'critical':
        return 'bg-error/10 border-error/20 text-error';
      case 'warning':
        return 'bg-warning/10 border-warning/20 text-warning';
      case 'info':
        return 'bg-primary/10 border-primary/20 text-primary';
      default:
        return 'bg-muted border-border text-muted-foreground';
    }
  };

  const getSeverityIcon = (severity) => {
    switch (severity) {
      case 'critical':
        return 'AlertCircle';
      case 'warning':
        return 'AlertTriangle';
      case 'info':
        return 'Info';
      default:
        return 'Bell';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 h-full">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground">Automation Alerts</h3>
        <div className="flex items-center gap-2">
          <span className="px-2 py-1 bg-error/10 text-error text-xs font-medium rounded-full">
            {alerts?.length} Active
          </span>
        </div>
      </div>
      <div className="space-y-3 max-h-96 overflow-y-auto">
        {alerts?.map((alert) => (
          <div key={alert?.id} className={`p-4 rounded-lg border ${getSeverityColor(alert?.severity)}`}>
            <div className="flex items-start gap-3 mb-3">
              <Icon name={getSeverityIcon(alert?.severity)} size={20} />
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-semibold mb-1">{alert?.title}</h4>
                <p className="text-xs opacity-90 mb-2">{alert?.message}</p>
                <div className="flex items-center gap-2 text-xs opacity-75">
                  <Icon name="Clock" size={12} />
                  <span>{alert?.timestamp}</span>
                </div>
              </div>
            </div>
            
            <div className="flex items-center gap-2">
              <Button
                variant="ghost"
                size="xs"
                iconName="RotateCw"
                iconPosition="left"
                onClick={() => onRetry(alert?.id)}
              >
                Retry
              </Button>
              <Button
                variant="ghost"
                size="xs"
                iconName="X"
                iconPosition="left"
                onClick={() => onDismiss(alert?.id)}
              >
                Dismiss
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AutomationErrorAlerts;